import { render, staticRenderFns } from "./AlertNotificationsList.vue?vue&type=template&id=c69170c4"
import script from "./AlertNotificationsList.vue?vue&type=script&lang=js"
export * from "./AlertNotificationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports